export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0005_thumb.3df0867d.jpg";